import * as React from 'react'
import { Link, NavLink } from 'widgets-for-react'

type Props =
  | {
      type: 'link'
      [key: string]: any
      to: string
      children?: any
      onClick?: () => void
    }
  | {
      type: 'navlink'
      [key: string]: any
      to: string
      children?: any
      onClick?: () => void
      activeClassName: string
    }

/*
This is a link that will automatically determine if it needs to be an <a> <Link> or <NavLink>
 */
export const ExternalLink = (props: Props) => {
  const linkProps = { ...props }
  delete linkProps.to
  delete linkProps.children
  delete linkProps.type
  props.type === 'navlink' ? delete linkProps.activeClassName : null

  return /^https?:\/\//.test(props.to) ? (
    <a {...linkProps} href={props.to} target="_blank" rel="noopener noreferrer">
      {props.children}
    </a>
  ) : /.pdf$/.test(props.to) || /.docx?$/.test(props.to) || /.pptx?$/.test(props.to) || /.xlsx?$/.test(props.to) ? (
    <a {...linkProps} href={props.to} target="_blank" rel="noopener noreferrer">
      {props.children}
    </a>
  ) : props.type === 'link' ? (
    <Link {...linkProps} to={props.to}>
      {props.children}
    </Link>
  ) : (
    <NavLink {...linkProps} to={props.to} activeClassName={props.activeClassName}>
      {props.children}
    </NavLink>
  )
}
